const SESSION_KEY = 'telemetry_session_id';

const getCookie = (name: string) => {
  const match = document.cookie
    .split(';')
    .map(entry => entry.trim())
    .find(entry => entry.startsWith(`${name}=`));
  if (!match) return '';
  return decodeURIComponent(match.slice(name.length + 1));
};

const getSessionId = () => {
  const existing = localStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const generated =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `sess-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  localStorage.setItem(SESSION_KEY, generated);
  return generated;
};

type TelemetryEvent = {
  event: string;
  properties?: Record<string, unknown>;
  pageUrl?: string;
};

export const trackEvent = (payload: TelemetryEvent) => {
  try {
    const hasAuth = Boolean(getCookie('auth_token'));
    const csrfToken = getCookie('csrf_token');
    const body = JSON.stringify({
      event: payload.event,
      properties: payload.properties || {},
      pageUrl: payload.pageUrl || window.location.href,
      sessionId: getSessionId(),
    });

    if (!hasAuth && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${process.env.REACT_APP_API_URL || 'http://localhost:3001/api'}/telemetry`, blob);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001/api'}/telemetry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(csrfToken ? { 'x-csrf-token': csrfToken } : {}),
      },
      body,
      keepalive: true,
      credentials: 'include',
    }).catch(() => undefined);
  } catch (error) {
    // ignore telemetry errors
  }
};
